import { ReactNode } from 'react';
import clsx from 'clsx';

import classes from './mediaLightbox.module.css';

export type MediaLightboxDetailRowProps = {
  label: string;
  stacked?: boolean;
  children: ReactNode;
};

const MediaLightboxDetailRow = ({
  label,
  stacked = false,
  children,
}: MediaLightboxDetailRowProps) => (
  <div className={clsx(classes.detailRow, stacked && classes.stacked)}>
    <div className={classes.detailLabel}>{`${label}:`}</div>
    <div className={classes.detailValue}>{children}</div>
  </div>
);

export default MediaLightboxDetailRow;
